// extracted by mini-css-extract-plugin
export default {"container":"Service_container__7lOY-","container_small":"Service_container_small__L46ya","container-lg":"Service_container-lg__m-KJS","main":"Service_main__IErs0"};